<template>
  <div class="creation-demand-success">
    <QPageContainer>
      <QPage padding>
        <section>
          <QIcon name="icon-extra-champagne" size="100px" color="secondary" />
          <h2>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@SUCCESS_TITLE")) }}</h2>
          <h2>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@SUCCESS_SUBTITLE") }}</h2>
        </section>
      </QPage>
    </QPageContainer>

    <QFooter class="bg-transparent">
      <div>
        <QBtn color="secondary" class="full-width btn-navigation" :label="$t('ETAB.BUTTONS.@GO_TO_DASHBOARD')" no-caps @click="goToDashboard" />
      </div>
    </QFooter>
  </div>
</template>

<script>
  import { ETAB_ROUTES } from "@etab/config";
  import { DataLayerManager } from "@core/managers/datalayer-manager";

  export default {
    mounted() {
      // stop any previous loading
      this.$_stopGlobalLoading();
      DataLayerManager.setData(
        { event: "creation", page_type: "formulaire", formulaire: "creation_annonce", formulaire_step_number: "11", creation_type: "temporary" },
        "etablissement",
        "etablissement",
      );
    },
    methods: {
      goToDashboard() {
        this.$router.push({ name: ETAB_ROUTES.dashboard.tabs.upcoming.name }).catch((suppressedError) => {});
      },
    },
  };
</script>

<style lang="scss">
  .creation-demand-success {
    @media screen and (max-width: $breakpoint-xs-max) {
      footer {
        button {
          border-radius: 0;
        }
      }
    }
  }
</style>
